import { combineReducers } from "redux";
import isLoading from './isLoading';

export default combineReducers({
    isLoading: isLoading,
})